import { Component, OnInit, Renderer2 } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import * as SecureLS from "secure-ls";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";
import { GlobalService } from "src/app/services/global.service";
import Math from "exact-math";
const Excel = require("exceljs");
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { CommonService } from "src/app/services/common.service";
import { StorageService } from "../../services/storage.service";

@Component({
  selector: "app-file-server",
  templateUrl: "./file-server.component.html",
  styleUrls: ["./file-server.component.css"],
})
export class FileServerComponent implements OnInit {
  // Modal
  closeResult: string;
  submitted = false;
  private ls = new SecureLS({ encodingType: "aes" });
  FileserverList: any[];
  page: number = 1;
  page_size: number = 10;
  getfileserver: Object;
  total_count: any;
  roleID = this.storageService.getRole();
  userID = this.ls.get("createdBy");
  active = 1;
  alphaPattern = "[a-zA-Z .,]*";
  ippattern =
    "(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)";
  serverip = "";
  FileserverForm: FormGroup;
  editbut = false;
  showLoadMore = false;
  departcreate: any;
  isactiveswitch: any;
  departupdate: any;
  editfileserver: Object;
  editid: any;
  editstatus: any;
  departstatusupdate: Object;
  deletefileserver: Object;
  page_count = [];
  pageshow = true;
  htmlpageshow: boolean;
  folder: any;
  availablememory: any;
  usedmemory:any;
  freememory:any;
  total: any;
  p: number;
  pagedItems: any[];
  writehide = false;
  writeaccess = this.ls.get("write_access");
  searchForm: FormGroup;
  filtervalues: boolean;
  chiparray: any = [];
  bulk_form: FormGroup;
  view_File_name: any;
  selectedFiles: any;
  bulkcreate: Object;
  entryFields: boolean = false;
  createNew: boolean = true;
  backendValidationErrors: null;

  constructor(
    private storageService: StorageService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService,
    public fileupload: CommonService,
    private renderer: Renderer2,
    private router: Router
  ) {}

  // Modal
  openScrollableContent(longContent) {
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
    }
  }
  async ngOnInit() {
    this.searchForm = this.fb.group({
      id: [""],
      fileip: [""],
      foldername: [""],
      availablememory:[""],
      usedmemory:[""],
      freememory:[""],
    });
    this.FileserverForm = this.fb.group({
      id: [""],
      serverip: ["", [Validators.required]],
      foldername: ["", [Validators.required]],
    });

    this.bulk_form = this.fb.group({
      bulk_file: [""],
    });
    this.page = 1;
    this.FileserverForm.valueChanges.subscribe((data)=>{
      this.backendValidationErrors = null;
    });
    if (this.ls.get("write_access") == 0) {
      this.writehide = true;
    }
    await this.getFileserver();
    await this.getPage(this.page, true);
  }

  navigateToHealthCheckup()
  {
    this.router.navigate([`/health-checkup`]);
  }

  openField() {
    this.entryFields = true;
    this.createNew = false;
    this.FileserverForm.reset();
    this.submitted = false;
  }
  openEdit() {
    this.entryFields = true;
    this.createNew = false;
    this.editbut = false;
    this.FileserverForm.reset();
    this.submitted = false;
  }

  onActiveTab(active) {
    if (active !== 1) {
      this.bulk_form.controls["bulk_file"].patchValue("");
    }
  }

  cancelFields() {
    this.renderer.removeClass(document.body, "modal-open");
    this.entryFields = false;
    this.FileserverForm.reset();
    this.bulk_form.reset();
    this.createNew = true;
  }
  get forms() {
    return this.FileserverForm.controls;
  }
  get forms1() {
    return this.searchForm.controls;
  }
  Filter(serverip, folder,availablememory,usedmemory,freememory) {
    this.filtervalues = true;
    this.chiparray = [];
    if (this.serverip != undefined && this.serverip != "") {
      this.chiparray.push("Server IP :" + " " + this.serverip);
    }

    if (this.folder != undefined && this.folder != "") {
      this.chiparray.push("Folder Name :" + " " + this.folder);
    }
    if (this.availablememory != undefined && this.availablememory != "") {
      this.chiparray.push("Available Memory :" + " " + this.availablememory);
    }
    if (this.usedmemory != undefined && this.usedmemory != "") {
      this.chiparray.push("Used Memory :" + " " + this.usedmemory);
    }
    if (this.freememory != undefined && this.freememory != "") {
      this.chiparray.push("Free Memory :" + " " + this.freememory);
    }
    this.serverip = serverip;
    this.folder = folder;
    this.availablememory = availablememory;
    this.usedmemory = usedmemory;
    this.freememory = freememory;
    if (serverip == null || serverip == "") {
      this.pageshow = true;
      this.page = 1;
      this.getFileserver();
    } else if (serverip != null) {
      let server_check = new RegExp(
        "((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(.|$)){4}"
      );
      let validate_ip = server_check.test(serverip);
      if (validate_ip === true) {
        this.serverip = serverip;
        this.pageshow = true;
        this.page = 1;
        this.getFileserver();
      } else {
        this.filtervalues = false;
        Swal.fire("warning", "Please Provide the Valid IP", "warning");
        return false;
      }
    }
  }
  res() {
    this.filtervalues = false;
    this.serverip = null;
    this.pageshow = true;
    this.page = 1;
    this.folder = null;
    this.availablememory = null;
    this.usedmemory = null;
    this.freememory = null;
    this.searchForm.reset();
    this.getFileserver();
  }
  async getPage(page: number, disableCall: boolean) {
    this.page = page;
    if(!disableCall){
    await this.getFileserver();
    }
    const res = await this.serverCall(this.FileserverList, page);
    this.total = this.total_count;
    this.p = page;

    this.pagedItems = res;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = this.page_size;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }
  async getFileserver() {
    this.spinner.show();
    if (this.page === 1) {
      this.FileserverList = [];
    }
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      page: this.page,
      page_size: this.page_size,
      role_id: this.storageService.getRole(),
      server_ip: this.serverip ? this.serverip : "",
      folder_name: this.folder ? this.folder : "",
      available_storage: this.searchForm.controls['availablememory'].value ? this.searchForm.controls['availablememory'].value : "",
      userd_storage: this.searchForm.controls['usedmemory'].value ? this.searchForm.controls['usedmemory'].value : "",
      free_storage: this.searchForm.controls['freememory'].value ? this.searchForm.controls['freememory'].value : "",
      
    };
    this.getfileserver = await this.globalService.get(
      "fileServer/list",
      filter
    );
    if (this.getfileserver["status"] === 200) {
      this.total_count = this.getfileserver["content"].count;
      if (this.getfileserver["content"]["rows"].length < this.page_size) {
        this.showLoadMore = true;
      }
      this.FileserverList = this.getfileserver["content"]["rows"];

      if (this.pageshow === true) {
        this.page_count = [];
        let page_count = Math.ceil(this.total_count / this.page_size);
        if (page_count > 1) {
          this.htmlpageshow = true;
        } else {
          this.htmlpageshow = false;
        }
      }
    } else {
      this.showLoadMore = true;
    }

    (error) => {
      this.FileserverList = [];
      this.spinner.hide();
      this.showLoadMore = true;
    };

    this.spinner.hide();
  }
  async createFileserver(form: FormGroup) {
    this.submitted = true;

    if (this.FileserverForm.invalid) {
      return;
    }
    this.spinner.show();
    const inputData = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      server_ip: form.value.serverip,
      folder_name: form.value.foldername,
      available_storage: form.value.availablememory,
      userd_storage: form.value.usedmemory,
      free_storage: form.value.freememory,
    };
    this.departcreate = await this.globalService.create(
      "fileServer/create",
      inputData
    );

    if (this.departcreate["status"] === 200) {
      Swal.fire("Success!", this.departcreate["message"], "success");
      this.pageshow = true;
      this.getFileserver();
      this.reset();
      this.bulk_form.reset();
      this.entryFields = false;
      this.createNew = true;
      this.backendValidationErrors = null;
      this.renderer.removeClass(document.body, 'modal-open')
    } else if (this.departcreate["status"] === 422) {
      this.backendValidationErrors = this.departcreate?.error["content"];
    } else {
      this.cancelFields();
      this.backendValidationErrors = null;
    }
    this.spinner.hide();
  }

  async deleteFileserver(id) {
    this.spinner.show();
    Swal.fire({
      title: "Delete ?",
      text: "Are you sure you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
        };
        this.deletefileserver = await this.globalService.delete(
          "fileServer/delete",
          filter
        );
        if (this.deletefileserver["status"] === 200) {
          this.FileserverList = [];
          Swal.fire("Success!", this.deletefileserver["message"], "success");
          this.pageshow = true;
          this.getFileserver();
        }
      }
    });
    this.spinner.hide();
  }

  async updateFileserver(form: FormGroup) {
    this.submitted = true;

    if (this.FileserverForm.invalid) {
      return;
    }
    this.spinner.show();

    const inputData = {
      id: form.value.id,
      vendor_id: this.ls.get("vendor_id"),
      server_ip: form.value.serverip,
      user_id: this.ls.get("createdBy"),
      folder_name: form.value.foldername,
      available_storage: form.value.availablememory,
    };
    this.departupdate = await this.globalService.update(
      "fileServer/update",
      inputData
    );

    if (this.departupdate["status"] === 200) {
      Swal.fire("Success!", this.departupdate["message"], "success");
      this.pageshow = true;
      this.getFileserver();
      this.editbut = false;
      this.reset();
      this.entryFields = false;
      this.createNew = true;
      this.backendValidationErrors = null;
      this.renderer.removeClass(document.body, 'modal-open')
    } else if (this.departupdate["status"] === 422) {
      this.backendValidationErrors = this.departupdate?.error["content"];
    } else {
      this.cancelFields();
      this.backendValidationErrors = null;
    }
    this.spinner.hide();
  }
  editFileserver(id, server_ip) {
    Swal.fire({
      title: "Edit ?",
      text: "Are you sure you want to edit this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        this.spinner.show();
        this.active = 2;

        this.editbut = true;
        this.openField();
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
          server_ip: server_ip,
        };
        this.editfileserver = await this.globalService.get(
          "fileServer/get",
          filter
        );
        let comp_details = this.editfileserver["content"];

        if (this.editfileserver["status"] === 200) {
          this.FileserverForm.controls["id"].setValue(comp_details.id);
          this.FileserverForm.controls["serverip"].setValue(
            comp_details.server_ip
          );
          this.FileserverForm.controls["foldername"].setValue(
            comp_details.folder_name
          );
         
          this.editid = comp_details.id;
        }

        this.spinner.hide();
      } else {
        this.cancelFields();
      }
    });
  }
  reset() {
    this.submitted = false;
    this.FileserverForm.reset();
  }

  resetbulk() {
    this.bulk_form.reset();
  }

  formAddReset() {
    this.FileserverForm.reset();
    this.editbut = false;
    this.bulk_form.reset();
  }
  formUpdateReset() {
    this.FileserverForm.controls["id"].setValue(
      this.editfileserver["content"].id
    );
    this.FileserverForm.controls["serverip"].setValue(
      this.editfileserver["content"].server_ip
    );
    this.FileserverForm.controls["foldername"].setValue(
      this.editfileserver["content"].folder_name
    );
   
  }

  async downloadSampleTemplate() {
    this.spinner.show();
    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");
    worksheet.getCell("A1").value = "Sno";
    worksheet.getCell("B1").value = "server_ip";
    worksheet.getCell("C1").value = "folder_name";
    worksheet.getCell("A2").value = "1";
    worksheet.getCell("B2").value = "172.20.1.4";
    worksheet.getCell("C2").value = "Fileserver_009";

    for (let i = 2; i < 2500; i++) {
      worksheet.getCell(`D${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        showInputMessage: false,
        formulae: ["$J$1:$J$1048576"],
      };
    }

    worksheet.getColumn(1).width = 20;
    worksheet.getColumn(2).width = 20;
    worksheet.getColumn(3).width = 20;
    worksheet.getColumn(4).width = 20;
    worksheet.getColumn(5).width = 20;
    worksheet.getColumn(6).width = 20;

    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "File server Sample List" + ".xlsx");
    });
    this.spinner.hide();
  }

  selectFile(event) {
    this.selectedFiles = event.target.files;
    this.view_File_name = this.selectedFiles.item(0).name;
  }

  async BulkUpload(form: FormGroup) {
    if (
      form.value.bulk_file === null ||
      form.value.bulk_file === undefined ||
      form.value.bulk_file === ""
    ) {
      Swal.fire("", "Please upload the file", "error");
    }
    let dataExport = [];
    let file;
    let files;

    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(this.selectedFiles[0]);
    if (this.selectedFiles != null) {
      const file = this.selectedFiles.item(0);
      if (
        file.type !== "application/vnd.ms-excel" &&
        file.type !==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        file.type !== "application/vnd.oasis.opendocument.spreadsheet"
      ) {
        this.spinner.hide();
        Swal.fire("Error!", "Only Excel files are allowed", "error");
        return;
      }

      if (file.size > 2097152) {
        Swal.fire("Warning!", "File Size Must be under 2 MB", "warning");
        return false;
      }
      if (
        file.type == "application/vnd.ms-excel" ||
        file.type ==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type == "application/vnd.oasis.opendocument.spreadsheet"
      ) {
        let formdata = new FormData();
        formdata.append("file", file);
        formdata.append("user_id", this.ls.get("createdBy"));
        formdata.append("vendor_id", this.ls.get("vendor_id"));
        formdata.append("upload_role_id", "4");
        formdata.append("role_id", String(this.storageService.getRole()));
        formdata.append("requester_type", "web");
        this.spinner.show();
        reader.onload = async (e: any) => {
          const binarystr: string = e.target.result;
          const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: "binary" });

          const wsname: string = wb.SheetNames[0];
          const ws: XLSX.WorkSheet = wb.Sheets[wsname];
          const data = XLSX.utils.sheet_to_json(ws);

          if (data.length > 100) {
            this.spinner.hide();
            Swal.fire(
              "Warning!",
              "Records more than 100 not be allowed",
              "warning"
            );

            return;
          } else {
            this.bulkcreate = await this.globalService.update(
              "fileServer/upload/excel",
              formdata
            );

            if (this.bulkcreate["status"] === 200) {
              let bulk = this.bulkcreate["content"];
              const expectedHeaders = ["server_ip", "folder_name"];
              const missingDataRows = bulk.filter((row) => {
                return expectedHeaders.some((header) => !row[header]);
              });
              if (missingDataRows.length > 0) {
                Swal.fire(
                  "Warning!",
                  "Some rows are missing data for required headers. Please check the file.",
                  "warning"
                );
              } else {
                for (let i = 0; i < bulk.length; i++) {
                  dataExport.push({
                    Sno: i + 1,
                    server_ip: bulk[i].server_ip,
                    folder_name: bulk[i].folder_name,
                    message: bulk[i].message,
                  });
                }

                var a = await this.fileupload.exportExcel(
                  dataExport,
                  "File server List"
                );
                Swal.fire("Success!", this.bulkcreate["message"], "success");
                this.pageshow = true;
                this.bulk_form.reset();
                this.resetbulk();
              }
            }
          }
          this.spinner.hide();
        };
      }
    }
    this.spinner.hide();
    this.cancelFields();
  }

  switch(e) {
    this.isactiveswitch = e;
  }
  loadMore(index) {
    this.pageshow = true;
    this.page = index;
    this.getFileserver();
  }
  previous() {
    this.pageshow = true;
    this.page = this.page - 1;
    this.getFileserver();
  }

  next() {
    this.pageshow = true;
    this.page = this.page + 1;
    this.getFileserver();
  }
  paginationCount(value) {
    this.page = 1;
    if (value >= 5) {
      this.page_size = value;
    }
    this.getFileserver();
  }
}
